<template>
  <div>
  <el-form
      :inline="true"
      :model="addForm"
      ref="addForm"
      autocomplete="on"
      size="mini"
      label-width="80px">
    <el-row :gutter="24">

      <el-col :span="12">

        <el-form-item label="姓名" prop="name"  size="small">
          <el-input v-model="addForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="card"  size="small">
          <el-input v-model="addForm.card" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
        <el-col :span="12">
        <el-form-item label="手机号" prop="mobile"  size="small">
          <el-input v-model="addForm.mobile" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="准驾车型" prop="drive_type"  size="small">
          <el-input v-model="addForm.drive_type" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">

      <el-col :span="8">
        <el-form-item>
          <el-upload class="uploader" :auto-upload="false" :show-file-list="false" drag :on-change="UploadImageCard" action="#">
            <i class="el-icon-upload" v-if="addForm.cardImageUrl == ''">
              <span class="fontStyle1">将身份证拖到此处，或
                <span class="fontStyle2">点击上传</span>
              </span>
            </i>
            <div class="uploaded" v-else :style="{'background-image': 'url(' + addForm.cardImageUrl + ')','width':'360px','height':'180px','background-size':'cover','margin-bottom':'200px'}">
              <span class="fontStyle3">
              <i class="el-icon-zoom-in"
                 @click="openWin('../../static/typeImg.html?typeImage=' + addForm.cardImageUrl)">查看图片</i>
              <i class="el-icon-delete-solid" @click.stop="delImg(1)">删除图片</i>
              <i class="el-icon-refresh-right" slot="trigger">重新上传</i>
              </span>
            </div>

          </el-upload>

        </el-form-item>


      </el-col>
      <el-col :span="8">
        <el-form-item>
          <el-upload class="uploader" :auto-upload="false" :show-file-list="false" drag :on-change="UploadImageDrive4" action="#">
            <i class="el-icon-upload" v-if="addForm.professionalImageUrl == ''">
              <span class="fontStyle1">将上岗证（从业资格证）拖到此处，或
                <span class="fontStyle2">点击上传</span>
              </span>
            </i>
            <div class="uploaded" v-else :style="{'background-image': 'url(' + addForm.professionalImageUrl + ')','width':'360px','height':'180px','background-size':'cover','margin-bottom':'200px'}">
<span class="fontStyle3">
                <i class="el-icon-zoom-in" @click="openWin('../../static/typeImg.html?typeImage=' +addForm.professionalImageUrl)">查看图片</i>
              <i class="el-icon-delete-solid" @click.stop="delImg(7)">删除图片</i>
              <i class="el-icon-refresh-right" slot="trigger">重新上传</i>
</span>

            </div>

          </el-upload>

        </el-form-item>


      </el-col>
      <el-col :span="8">
        <el-form-item>
          <el-upload class="uploader" :auto-upload="false" :show-file-list="false" drag :on-change="UploadImageDrive" action="#">
            <i class="el-icon-upload" v-if="addForm.driveImageUrl == ''">
              <span class="fontStyle1">将驾驶证拖到此处，或
                <span class="fontStyle2">点击上传</span>
              </span>
            </i>
            <div class="uploaded" v-else :style="{'background-image': 'url(' + addForm.driveImageUrl + ')','width':'360px','height':'180px','background-size':'cover','margin-bottom':'200px'}">
<span class="fontStyle3">
                <i class="el-icon-zoom-in" @click="openWin('../../static/typeImg.html?typeImage=' +addForm.driveImageUrl)">查看图片</i>
              <i class="el-icon-delete-solid" @click.stop="delImg(2)">删除图片</i>
              <i class="el-icon-refresh-right" slot="trigger">重新上传</i>
</span>

            </div>

          </el-upload>

        </el-form-item>


      </el-col>
    </el-row>
    <el-row :gutter="24" style=" padding-top: 10px; border-top: #3a8ee6 1px solid;">

      <el-col :span="12">

        <el-form-item label="姓名" prop="name"  size="small">
          <el-input v-model="addForm.name2" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="card"  size="small">
          <el-input v-model="addForm.card2" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="手机号" prop="mobile"  size="small">
          <el-input v-model="addForm.mobile2" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="准驾车型" prop="drive_type"  size="small">
          <el-input v-model="addForm.drive_type2" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24" >
      <el-col :span="8">
        <el-form-item>
          <el-upload class="uploader" :auto-upload="false" :show-file-list="false" drag :on-change="UploadImageCard2" action="#">
            <i class="el-icon-upload" v-if="addForm.cardImageUrl2 == ''">
              <span class="fontStyle1">将身份证拖到此处，或
                <span class="fontStyle2">点击上传</span>
              </span>
            </i>
            <div class="uploaded" v-else :style="{'background-image': 'url(' + addForm.cardImageUrl2 + ')','width':'360px','height':'180px','background-size':'cover','margin-bottom':'200px'}">
              <span class="fontStyle3">
              <i class="el-icon-zoom-in"
                 @click="openWin('../../static/typeImg.html?typeImage=' + addForm.cardImageUrl2)">查看图片</i>
              <i class="el-icon-delete-solid" @click.stop="delImg(3)">删除图片</i>
              <i class="el-icon-refresh-right" slot="trigger">重新上传</i>
              </span>
            </div>

          </el-upload>

        </el-form-item>


      </el-col>
      <el-col :span="8">
        <el-form-item>
          <el-upload class="uploader" :auto-upload="false" :show-file-list="false" drag :on-change="UploadImageDrive5" action="#">
            <i class="el-icon-upload" v-if="addForm.professionalImageUrl2 == ''">
              <span class="fontStyle1">将上岗证（从业资格证）拖到此处，或
                <span class="fontStyle2">点击上传</span>
              </span>
            </i>
            <div class="uploaded" v-else :style="{'background-image': 'url(' + addForm.professionalImageUrl2 + ')','width':'360px','height':'180px','background-size':'cover','margin-bottom':'200px'}">
<span class="fontStyle3">
                <i class="el-icon-zoom-in" @click="openWin('../../static/typeImg.html?typeImage=' +addForm.professionalImageUrl2)">查看图片</i>
              <i class="el-icon-delete-solid" @click.stop="delImg(8)">删除图片</i>
              <i class="el-icon-refresh-right" slot="trigger">重新上传</i>
</span>

            </div>

          </el-upload>

        </el-form-item>


      </el-col>
      <el-col :span="8">
        <el-form-item>
          <el-upload class="uploader" :auto-upload="false" :show-file-list="false" drag :on-change="UploadImageDrive2" action="#">
            <i class="el-icon-upload" v-if="addForm.driveImageUrl2 == ''">
              <span class="fontStyle1">将驾驶证拖到此处，或
                <span class="fontStyle2">点击上传</span>
              </span>
            </i>
            <div class="uploaded" v-else :style="{'background-image': 'url(' + addForm.driveImageUrl2 + ')','width':'360px','height':'180px','background-size':'cover','margin-bottom':'200px'}">
<span class="fontStyle3">
                <i class="el-icon-zoom-in" @click="openWin('../../static/typeImg.html?typeImage=' +addForm.driveImageUrl2)">查看图片</i>
              <i class="el-icon-delete-solid" @click.stop="delImg(4)">删除图片</i>
              <i class="el-icon-refresh-right" slot="trigger">重新上传</i>
</span>

            </div>

          </el-upload>

        </el-form-item>


      </el-col>
    </el-row>
    <el-row :gutter="24" style=" padding-top: 10px; border-top: #3a8ee6 1px solid;">

      <el-col :span="12">

        <el-form-item label="姓名" prop="name"  size="small">
          <el-input v-model="addForm.name3" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="card"  size="small">
          <el-input v-model="addForm.card3" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="手机号" prop="mobile"  size="small">
          <el-input v-model="addForm.mobile3" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="准驾车型" prop="drive_type"  size="small">
          <el-input v-model="addForm.drive_type3" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24" >

      <el-col :span="8">
        <el-form-item>
          <el-upload class="uploader" :auto-upload="false" :show-file-list="false" drag :on-change="UploadImageCard3" action="#">
            <i class="el-icon-upload" v-if="addForm.cardImageUrl3 == ''">
              <span class="fontStyle1">将身份证拖到此处，或
                <span class="fontStyle2">点击上传</span>
              </span>
            </i>
            <div class="uploaded" v-else :style="{'background-image': 'url(' + addForm.cardImageUrl3 + ')','width':'360px','height':'180px','background-size':'cover','margin-bottom':'200px'}">
              <span class="fontStyle3">
              <i class="el-icon-zoom-in"
                 @click="openWin('../../static/typeImg.html?typeImage=' + addForm.cardImageUrl3)">查看图片</i>
              <i class="el-icon-delete-solid" @click.stop="delImg(5)">删除图片</i>
              <i class="el-icon-refresh-right" slot="trigger">重新上传</i>
              </span>
            </div>

          </el-upload>

        </el-form-item>


      </el-col>
      <el-col :span="8">
        <el-form-item>
          <el-upload class="uploader" :auto-upload="false" :show-file-list="false" drag :on-change="UploadImageDrive6" action="#">
            <i class="el-icon-upload" v-if="addForm.professionalImageUrl3 == ''">
              <span class="fontStyle1">将上岗证（从业资格证）拖到此处，或
                <span class="fontStyle2">点击上传</span>
              </span>
            </i>
            <div class="uploaded" v-else :style="{'background-image': 'url(' + addForm.professionalImageUrl3 + ')','width':'360px','height':'180px','background-size':'cover','margin-bottom':'200px'}">
<span class="fontStyle3">
                <i class="el-icon-zoom-in" @click="openWin('../../static/typeImg.html?typeImage=' +addForm.professionalImageUrl3)">查看图片</i>
              <i class="el-icon-delete-solid" @click.stop="delImg(9)">删除图片</i>
              <i class="el-icon-refresh-right" slot="trigger">重新上传</i>
</span>

            </div>

          </el-upload>

        </el-form-item>


      </el-col>
      <el-col :span="8">
        <el-form-item>
          <el-upload class="uploader" :auto-upload="false" :show-file-list="false" drag :on-change="UploadImageDrive3" action="#">
            <i class="el-icon-upload" v-if="addForm.driveImageUrl3 == ''">
              <span class="fontStyle1">将驾驶证拖到此处，或
                <span class="fontStyle2">点击上传</span>
              </span>
            </i>
            <div class="uploaded" v-else :style="{'background-image': 'url(' + addForm.driveImageUrl3 + ')','width':'360px','height':'180px','background-size':'cover','margin-bottom':'200px'}">
<span class="fontStyle3">
                <i class="el-icon-zoom-in" @click="openWin('../../static/typeImg.html?typeImage=' +addForm.driveImageUrl3)">查看图片</i>
              <i class="el-icon-delete-solid" @click.stop="delImg(6)">删除图片</i>
              <i class="el-icon-refresh-right" slot="trigger">重新上传</i>
</span>

            </div>

          </el-upload>

        </el-form-item>


      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col style="display:flex;flex-direction: row;justify-content: flex-end">
        <el-form-item>
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="save('addForm')">保存</el-button>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
    <!-- 全局遮罩 图片上传 -->
    <el-dialog :visible.sync="dialogVisible" :modal="true" :close-on-click-modal="false" :close-on-press-escape="false" width="50%">
      <div class="loading-overlay">
        <div class="loading-spinner" style="font-size:30px;font-weight: bold">
          <i class="el-icon-upload"></i>
          图片上传ing
          <i class="el-icon-loading"></i>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "carDrive",
  props: ['childData'],
  data() {
    return {
      newData: '',
      //车辆信息-大本
      dialogVisible: false,
      overlayClass: 'loading-overlay', // 遮罩元素的类名
      driver_info:[],
      addForm:{
        name:'',
        card:'',
        mobile:'',
        drive_type:'',
        cardImageUrl:'',
        driveImageUrl:'',
        professionalImageUrl:'',
        name2:'',
        card2:'',
        mobile2:'',
        drive_type2:'',
        cardImageUrl2:'',
        driveImageUrl2:'',
        professionalImageUrl2:'',
        name3:'',
        card3:'',
        mobile3:'',
        drive_type3:'',
        cardImageUrl3:'',
        driveImageUrl3:'',
        professionalImageUrl3:'',
      },

    }
  },
  mounted() {
    if(this.childData){
      this.getCarInfo()
    }
  },
  methods:{
    close(){},
    save(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param={
            car_id:this.childData,
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            driveList:[
              {
                name:this.addForm.name,
                card:this.addForm.card,
                mobile:this.addForm.mobile,
                drive_type:this.addForm.drive_type,
                cardImageUrl:this.addForm.cardImageUrl,
                driveImageUrl:this.addForm.driveImageUrl,
                professionalImageUrl:this.addForm.professionalImageUrl,
              },
              {
                name:this.addForm.name2,
                card:this.addForm.card2,
                mobile:this.addForm.mobile2,
                drive_type:this.addForm.drive_type2,
                cardImageUrl:this.addForm.cardImageUrl2,
                driveImageUrl:this.addForm.driveImageUrl2,
                professionalImageUrl:this.addForm.professionalImageUrl2,
              },
              {
                name:this.addForm.name3,
                card:this.addForm.card3,
                mobile:this.addForm.mobile3,
                drive_type:this.addForm.drive_type3,
                cardImageUrl:this.addForm.cardImageUrl3,
                driveImageUrl:this.addForm.driveImageUrl3,
                professionalImageUrl:this.addForm.professionalImageUrl3,
              },
            ]
          };
          //console.log('save------',param);
          this.$axios.carMainAddDriver(param).then(res =>{
            if(res.code == 200){
              this.$message.success(res.msg)
              // this.$router.push('/carList')
            }else{
              this.$message.error(res.msg);
            }
          })
        }
      });


    },
    updateChildData() {
      this.newData = '更新后的子组件数据';
      this.$emit('update-parent-data', this.newData);
    },
    delImg(type){
      switch (type){
        case 1:
          this.addForm.cardImageUrl = '';
          break;
        case 2:
          this.addForm.driveImageUrl = '';
          break;
        case 3:
          this.addForm.cardImageUrl2 = '';
          break;
        case 4:
          this.addForm.driveImageUrl2 = '';
          break;
        case 5:
          this.addForm.cardImageUrl3 = '';
          break;
        case 6:
          this.addForm.driveImageUrl3 = '';
          break;
        case 7:
          this.addForm.professionalImageUrl = '';
          break;
        case 8:
          this.addForm.professionalImageUrl2 = '';
          break;
        case 9:
          this.addForm.professionalImageUrl3 = '';
          break;
      }
    },
    //上传图片的方法
    UploadImageCard(file) {
      this.addForm.cardImageUrl = URL.createObjectURL(file.raw);
      //console.log('UploadImageCard-file', file)
      this.commonUploadFuc(file,1)

    },
    UploadImageDrive(file) {
      this.addForm.driveImageUrl = URL.createObjectURL(file.raw);
      //console.log('UploadImageDrive-file', file)
      this.commonUploadFuc(file,2)

    },
    //上传图片的方法
    UploadImageCard2(file) {
      this.addForm.cardImageUrl2 = URL.createObjectURL(file.raw);
      //console.log('UploadImageCard-file', file)
      this.commonUploadFuc(file,3)

    },
    UploadImageDrive2(file) {
      this.addForm.driveImageUrl2 = URL.createObjectURL(file.raw);
      //console.log('UploadImageDrive-file', file)
      this.commonUploadFuc(file,4)

    },
    //上传图片的方法
    UploadImageCard3(file) {
      this.addForm.cardImageUrl3 = URL.createObjectURL(file.raw);
      //console.log('UploadImageCard-file', file)
      this.commonUploadFuc(file,5)

    },
    UploadImageDrive3(file) {
      this.addForm.driveImageUrl3 = URL.createObjectURL(file.raw);
      //console.log('UploadImageDrive-file', file)
      this.commonUploadFuc(file,6)

    },
    UploadImageDrive4(file) {
      this.addForm.professionalImageUrl = URL.createObjectURL(file.raw);
      //console.log('UploadImageDrive-file', file)
      this.commonUploadFuc(file,7)

    },
    UploadImageDrive5(file) {
      this.addForm.professionalImageUrl2 = URL.createObjectURL(file.raw);
      //console.log('UploadImageDrive-file', file)
      this.commonUploadFuc(file,8)

    },
    UploadImageDrive6(file) {
      this.addForm.professionalImageUrl3 = URL.createObjectURL(file.raw);
      //console.log('UploadImageDrive-file', file)
      this.commonUploadFuc(file,9)

    },
    //公共上传图片到oss
    commonUploadFuc(file,type){
      this.dialogVisible = true;
      let img_type = 13;
      if(type ==2||type ==4||type==6){
        img_type = 14;
      }else if(type ==7||type ==8||type ==9){
        img_type = 16;
      }
      let payFd = new FormData()
      payFd.append('file', file.raw)
      payFd.append('img_type', img_type)
      payFd.append('company_id', sessionStorage.getItem('company_id'))
      payFd.append('access_token', sessionStorage.getItem('token'))
      this.$axios.carUploadImage(payFd).then(res => {
        if (res.code == 200) {
          //console.log('oss-src',res.data.src)
          switch (type){
            case 1:
              this.addForm.cardImageUrl = res.data.src;
              break;
            case 2:
              this.addForm.driveImageUrl = res.data.src;
              break;
            case 3:
              this.addForm.cardImageUrl2 = res.data.src;
              break;
            case 4:
              this.addForm.driveImageUrl2 = res.data.src;
              break;
            case 5:
              this.addForm.cardImageUrl3 = res.data.src;
              break;
            case 6:
              this.addForm.driveImageUrl3 = res.data.src;
              break;
            case 7:
              this.addForm.professionalImageUrl = res.data.src;
              break;
            case 8:
              this.addForm.professionalImageUrl2 = res.data.src;
              break;
            case 9:
              this.addForm.professionalImageUrl3 = res.data.src;
              break;
          }
          this.dialogVisible = false;
          this.$message.success(res.msg)
        }else{
          this.$message.error(res.msg)
        }
      }).catch(error => console.log('UploadImage-error',error))

    },
    openWin(url) {
      var name;                           //网页名称，可为空;
      var iWidth = 500;                         //弹出窗口的宽度;
      var iHeight = 570;                        //弹出窗口的高度;
      //window.screen.height获得屏幕的高，window.screen.width获得屏幕的宽
      var iTop = (window.screen.height - 30 - iHeight) / 2;       //获得窗口的垂直位置;
      var iLeft = (window.screen.width - 10 - iWidth) / 2;        //获得窗口的水平位置;
      window.open(url, name, 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',toolbar=no,menubar=no,scrollbars=auto,resizable=no,location=no,status=no');
    },
    //获取车辆档案信息
    getCarInfo(){
      let _this=this;
      let param = {
        id:this.childData,
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      };
      this.$axios.carInfo(param).then(res =>{
        if(res.code == 200){
          const driver_info=res.data.driver_info
          driver_info.forEach(function(item,index) {
            //console.log('look-driver_info',item);
            if(index==0){
              _this.addForm.name = item.name;
              _this.addForm.card = item.card;
              _this.addForm.mobile = item.mobile;
              _this.addForm.drive_type = item.drive_type;
              _this.addForm.cardImageUrl = item.card_img;
              _this.addForm.driveImageUrl = item.driver_img;
              _this.addForm.professionalImageUrl = item.work_img;
            }else if(index==1){
              _this.addForm.name2 = item.name;
              _this.addForm.card2 = item.card;
              _this.addForm.mobile2 = item.mobile;
              _this.addForm.drive_type2 = item.drive_type;
              _this.addForm.cardImageUrl2 = item.card_img;
              _this.addForm.driveImageUrl2 = item.driver_img;
              _this.addForm.professionalImageUrl2 = item.work_img;
            }else if(index==2){
              _this.addForm.name3 = item.name;
              _this.addForm.card3 = item.card;
              _this.addForm.mobile3 = item.mobile;
              _this.addForm.drive_type3 = item.drive_type;
              _this.addForm.cardImageUrl3 = item.card_img;
              _this.addForm.driveImageUrl3 = item.driver_img;
              _this.addForm.professionalImageUrl3 = item.work_img;
            }
          });
        }else{
          this.$message.error(res.msg);
        }
      })
    },
  }
}
</script>

<style scoped>

.fontStyle1{
  display: block;
  font-size:14px;
  color: #606266;
}
.fontStyle2,.fontStyle3{
  font-size:14px;
  color: #3a8ee6;
}
.fontStyle3{
  font-size:22px;
  color: #999;
  position: absolute;
  bottom: 1px;
  right: 1px;
}
</style>


// WEBPACK FOOTER //
// src/view/common/carDrive.vue